import React from 'react';
import CCMRSSyle from '../style';
import ItemGrid from '../../../components/itemGrid';
import StrechSection from '../../../components/strechSection';
import NextBackNav from '../../../components/nextBackNav';

export default function Page03({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = CCMRSSyle();
	return (
		<div style={style.outerStyle()}>
			<h1 style={style.titleStyle()}>Arsenal</h1>
			<ItemGrid
				smallTitles={['Alpha Selection']}
				rows={[
					['BACK', 'Chest', 'Legs'],
					['Dumbbell Rows', 'Standard Bench Press (BB)', 'Standard Squats'],
					['Deadlifts', 'Dumbbell Bench Press', 'Dumbbell Bench Press'],
					['Bent-Over Rows', 'Decline Standard Bench Press', 'Wide-Stance Box Squats'],
					['', '', 'Dumbbell Goblet Squats'],
					['', '', 'Leg Extensions (optional)'],
				]}
				mt={true}
			/>
			<ItemGrid
				smallTitles={['Beta / Beta-Cardio Selection']}
				mt={true}
				rows={[
					['BACK', 'Chest', 'Legs', 'Cardio'],
					['Wide-Grip Pullups', 'Pushups', 'Sissy Squats', 'Burpees'],
					['Underhand-Grip Pull-Ups', '(Resistant Banded) Pushups', 'Air Squats', 'Jump Ropes'],
					['Kettlebell Shrugs', 'Dips', '(No Weights) Lunges', 'Jumping Jacks'],
					['(Resistance Bands) Rows', '(Resistance Bands) Flys', 'Step-Ups', 'Jump Squats'],
					['', 'Chest Plate Squeeze', 'Wall Sits', 'Dancing'],
					['', '(Light) Dumbbell Press', '', 'Running the Stairs'],
					['', '', '', 'Jogging in Place'],
				]}
			/>
			<ItemGrid
				mt={true}
				smallTitles={['Stretch Exercises']}
				rows={[
					['Hips', 'Shoulders', 'Hamstrings'],
					['Knee to Chest Stretch', 'Thread the Needle', 'Lying hamstring stretch/Strap'],
					[
						'90/90 Stretch',
						'Elbow-Out Rotator Stretch Cross-Body Shoulder Stretch',
						'Sitting hamstring stretch',
					],
					['Figure Four Stretch', 'Cross-Body Shoulder Stretch', 'Standing Hamstring Stretch'],
					['Piriformis Stretch', 'Overhead Triceps and Shoulder Stretch', ''],
					['Lunging Hip Flexor Stretch', 'Reverse Shoulder Stretch', ''],
					['Pigeon Stretch', '', ''],
					['Spiderman Stretch', '', ''],
					['Butterfly Fly Stretch', '', ''],
				]}
			/>
			<ItemGrid
				mt={true}
				rows={[
					['Lower Back', 'Glutes', 'Quad'],
					['Knee to Chest Stretch', '90/90', 'Kneeling Lunge'],
					['Figure Four Stretch', 'Half Lord of the Fishes', 'Standing Quad Stretch'],
					['Piriformis Stretch', 'Lizard Pose Variation', ''],
					["Child's Pose", 'Pigeon Pose', ''],
					['Cobra Stretch', '', ''],
					['Bird-Dog Stretch', '', ''],
				]}
			/>
			<StrechSection
				mt={true}
				title='YOU HAVE TO STRETCH!!!!'
				caption='Keep the muscles flexible, strong, and healthy, and we need that flexibility to maintain a range of motion in the joints. Without it, the muscles shorten and become tight. Then, when you call on the muscles for activity, they are weak and unable to extend all the way.'
				subTitle='FIVE BENEFITS'
				texts={[
					'* Stretching can improve posture. Tight muscles can cause poor posture',
					'* Stretching can improve the range of motion and prevents loss of range of motion.',
					'* Stretching decreases back pain',
					'* Stretching helps prevent injury',
					'* Stretching can decrease muscle soreness',
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
